//TODO: Move to Chops?

const setSessionStorageValue = (storageKey: string, itemValue: string): void => {
  try {
    sessionStorage.setItem(storageKey, itemValue);
  } catch {
    //Do Nothing
  }
};

export default setSessionStorageValue;
